import { Body as e, Small as t } from "../../Typography/Typography.mjs";
import { VStack as n } from "../Primitives/Stack.mjs";
import "react";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
//#region src/components/Field/Field.tsx
var a = ({ label: a, value: o }) => /* @__PURE__ */ i(n, {
	gap: .25,
	children: [/* @__PURE__ */ r(t, {
		color: "secondary",
		children: a
	}), /* @__PURE__ */ r(e, { children: o ?? "—" })]
});
//#endregion
export { a as Field };
